<div class="wrapper pt-4">
  <div class="page-wrapper">
    <div class="page-content pt-0 pe-xl-0 ps-xl-0 pe-2 ps-2">
      <div class="container-fluid">
        <!-- KPIs -->
        <div class="row g-3 mb-4 align-items-stretch">
          <div class="col-xl-12">
            <h5 class="mb-0 mt-2">Application Overeview</h5>
          </div>
          <div class="col-md-6 col-lg-4 col-xl-3" *ngIf="roleId == 1">
            <div class="card card-soft kpi h-100">
              <div class="card-body p-2" style="padding-bottom: 0px !important">
                <div class="kpi-head">
                  <div class="mini-title fw-semibold">Applications</div>
                  <div class="d-flex gap-2"></div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="value">
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="
                        registrationDetails(2, 'Applied', applied?.course_id)
                      ">{{ appliedCount?.COUNT1 }}</a>
                  </div>
                  &nbsp;

                  <!-- <span class="pill">Applied</span>&nbsp; -->
                  <span class="pill">In Progress:
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="
                        registrationDetails(
                          3,
                          'Application in Progress',
                          applicationInPorgrs?.course_id
                        )
                      ">
                      <b>{{ appliedCount?.REVIEWCOUNT }}</b></a></span>
                  &nbsp;
                  <span class="icon-soft"><i class="bi bi-graph-up"></i></span>
                </div>

                <!-- <div class="d-flex align-items-center">
                  <span class="pill"
                    >In Progress:
                    <a
                      class="count-color"
                      href="javascript:void()"
                      data-bs-target="#count"
                      data-bs-toggle="modal"
                      (click)="
                        registrationDetails(
                          3,
                          'Application in Progress',
                          applicationInPorgrs?.course_id
                        )
                      "
                    >
                      <b>{{ appliedCount?.REVIEWCOUNT }}</b></a
                    ></span
                  >
                  &nbsp;
                  <span class="icon-soft"><i class="bi bi-graph-up"></i></span>
                </div> -->
              </div>
              <div class="card-footer border-0 bg-white" style="padding-top: 0px !important">
                <div class="hint mt-1 ms-2">Current applied status</div>
                <div class="d-flex mt-0 align-items-center justify-content-between pt-1">
                  <span class="chip text-info"><i class="bi bi-people"></i>&nbsp; Interested Applicants:
                    <a style="color: #0dcaf0;font-size:9px" href="javascript:void();" data-bs-target="#count"
                      data-bs-toggle="modal" (click)="
                        registrationDetails(1, 'Signed up', signedUp?.course_id)
                      ">
                      <b>{{ appliedCount?.REJECTEDCOUNT }}</b></a></span>
                </div>
                <div class="d-flex mt-0 align-items-center justify-content-between pt-1">
                  <span class="chip text-info"><i class="bi bi-people"></i>&nbsp; Reverify:
                    <a style="color: #0dcaf0;;font-size:9px" href="javascript:void();" data-bs-target="#count"
                      data-bs-toggle="modal" (click)="
                        registrationDetails(
                          24,
                          'Signed up',
                          signedUp?.course_id
                        )
                      ">
                      <b>{{ appliedCount?.OFFERREJECTCOUNT }}</b></a></span>
                  <span>
                    <!-- <span class="icon-soft btn btn-sm btn-outline-primary"> <a href="javascript:void();" class=""> <i class="bi bi-download small"></i></a></span>  &nbsp; -->

                    <span class="icon-soft btn btn-sm btn-outline-light eye-circle">
                      <a href="javascript:void();" class="eye-link" data-bs-target="#count" data-bs-toggle="modal"
                        (click)="
                        registrationDetails(2, 'Applied', applied?.course_id)
                      ">
                        <i class="bi bi-eye"></i>
                      </a>
                    </span>

                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="card card-soft kpi h-100">
              <div class="card-body p-2">
                <div class="kpi-head">
                  <div class="mini-title fw-semibold mb-0">Admitted</div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="value">
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="
                        registrationDetails(4, 'Admitted', admitted?.course_id)
                      ">{{ admittedCount?.COUNT1 }}</a>
                  </div>
                  &nbsp;
                  <span class="pill">In Review:
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="
                        registrationDetails(
                          5,
                          'In Review',
                          in_review?.course_id
                        )
                      "><b>{{ admittedCount?.REVIEWCOUNT }}</b></a></span>
                  <!-- <span class="icon-soft"><i class="bi bi-person-check"></i></span> -->
                </div>
              </div>
              <div class="card-footer border-0 bg-white">
                <div class="hint mt-0">Current admitted student status</div>
                <div class="d-flex justify-content-between align-items-center pt-1">
                  <span class="chip text-danger"><i class="bi bi-x-circle"></i>&nbsp; L2 Rejected:
                    <a style="color: red;;font-size:9px" href="javascript:void();" data-bs-target="#count"
                      data-bs-toggle="modal" (click)="
                        registrationDetails(6, 'Rejected', rejected?.course_id)
                      ">
                      <b>{{ admittedCount?.REJECTEDCOUNT }}</b></a></span>
                </div>
                <div class="d-flex justify-content-between align-items-center pt-1">
                  <span class="chip text-danger"><i class="bi bi-x-circle"></i>&nbsp; Offer Rejected:
                    <a style="color: red;;font-size:9px" href="javascript:void();" data-bs-target="#count"
                      data-bs-toggle="modal" (click)="
                        registrationDetails(
                          22,
                          'Offer Rejected',
                          rejected?.course_id
                        )
                      ">
                      <b>{{ admittedCount?.OFFERREJECTCOUNT }}</b></a></span>

                  <span>
                    <!-- <span class="icon-soft btn btn-sm btn-outline-primary">
                      <a href="javascript:void();" class="">
                        <i class="bi bi-download small"></i></a></span>
                    &nbsp; -->


                    <span class="icon-soft btn btn-sm btn-outline-light eye-circle">
                      <a href="javascript:void();" data-bs-target="#count" data-bs-toggle="modal" (click)="
                          registrationDetails(
                            4,
                            'Admitted',
                            admitted?.course_id
                          )
                        ">
                        <i class="bi bi-eye"></i>
                      </a>
                    </span>

                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="card card-soft kpi h-100">
              <div class="card-body p-2">
                <div class="kpi-head">
                  <div class="mini-title fw-semibold">Enrolled</div>
                </div>
                <div class="d-flex align-items-center">
                  <div class="value">
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="
                        registrationDetails(13, 'Enroled', enroll?.course_id)
                      ">{{ registeredCount?.COUNT1 }}</a>
                  </div>
                  &nbsp;
                  <span class="pill">In Review:
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="
                        registrationDetails(
                          15,
                          'In Review',
                          sentBack?.course_id
                        )
                      "><b>{{ registeredCount?.REVIEWCOUNT }}</b></a></span>
                  <!-- <span class="icon-soft"><i class="bi bi-person-check"></i></span> -->
                </div>
              </div>
              <div class="card-footer border-0 bg-white">
                <div class="hint mt-1">Current registered status</div>
                <div class="d-flex mt-0 justify-content-between align-items-center pt-1">
                  <span class="chip text-success"><i class="bi bi-check2-circle"></i>&nbsp; Accepted:
                    <a style="color: #20943d;font-size:9px" href="javascript:void();" data-bs-target="#count"
                      data-bs-toggle="modal" (click)="
                        registrationDetails(
                          14,
                          'Accepted',
                          notEnroll?.course_id
                        )
                      ">
                      <b>{{ registeredCount?.REJECTEDCOUNT }}</b></a></span>
                </div>
                <div class="d-flex mt-0 justify-content-between align-items-center pt-1">
                  <span class="chip text-success"><i class="bi bi-check2-circle"></i>&nbsp; Initiated:
                    <a style="color: #20943d;font-size:9px" href="javascript:void();" data-bs-target="#count"
                      data-bs-toggle="modal" (click)="
                        registrationDetails(
                          23,
                          'Enrollment Initiated',
                          notEnroll?.course_id
                        )
                      ">
                      <b>{{ registeredCount?.OFFERREJECTCOUNT }}</b></a></span>
                  <span>
                    <!-- <span class="icon-soft btn btn-sm btn-outline-primary p-1">
                      <a href="javascript:void();" class=""><i class="bi bi-download small"></i></a></span>
                    &nbsp; -->
                    <span class="icon-soft btn btn-sm btn-outline-light eye-circle">
                      <a href="javascript:void();" class="eye-link" data-bs-target="#count" data-bs-toggle="modal"
                        (click)="
                        registrationDetails(13, 'Enroled', enroll?.course_id)
                      ">
                        <i class="bi bi-eye"></i>
                      </a>
                    </span>

                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 col-xl-3">
            <div class="card card-soft kpi h-100">
              <div class="card-body p-2">
                <div class="kpi-head">
                  <div class="mini-title fw-semibold">Graduated</div>
                  <a class="small text-decoration-none" href="javascript:void()">Alumni:
                    <a href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="registrationDetails(17, 'Alumni', 0)">{{ aluminiCount?.COUNT1 }}</a></a>
                </div>
                <div class="d-flex align-items-center">
                  <div class="value">
                    <a class="count-color" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="registrationDetails(18, 'Graduated', 0)">{{ graduationCount?.COUNT1 }}</a>
                  </div>
                  &nbsp;
                  <span class="pill">Programmes:
                    <b>
                      <a class="count-color" href="javascript:void()" data-bs-target="#programmePopup"
                        data-bs-toggle="modal" (click)="registrationDetails(18, 'Graduated', 0)">{{
                        graduationCount?.REVIEWCOUNT }}</a></b></span>
                </div>
              </div>
              <div class="card-footer border-0 bg-white">
                <div class="hint mt-1">Current graduation list status</div>

                <div class="d-flex mt-0 align-items-center justify-content-end pt-1">
                  <span class="icon-soft btn btn-sm btn-outline-light">
                    <a href="javascript:void();" data-bs-target="#count" data-bs-toggle="modal"
                      (click)="registrationDetails(17, 'Alumni', 0)">
                      <i class="bi bi-eye"></i>
                    </a>
                  </span>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Admissions & Registration -->
        <div class="row g-3 mb-4 align-items-stretch">
          <div class="col-xl-12">
            <h5 class="mb-0">Admissions and Registration</h5>
          </div>
          <div class="col-lg-4">
            <div class="card card-soft h-100">
              <div class="card-body">
                <!-- Admitted Box -->
                <div class="border rounded-3 p-3 mb-2 bg-light">
                  <div class="text-uppercase small text-muted fw-semibold mb-0">
                    Admitted
                  </div>
                  <div class="h3 fw-bold mb-0">{{ admittedCount?.COUNT1 }}</div>
                </div>

                <!-- Pending Admissions -->
                <div class="mb-0">
                  <div class="small text-muted fw-bold">Pending Admissions</div>
                  <div class="fw-semibold h4">{{ appliedCount?.COUNT1 }}</div>
                  <div class="small text-muted">
                    Students offered admission but not confirmed
                  </div>
                </div>

                <!-- Drop-Off Rate -->
                <div class="mb-0">
                  <div class="small text-muted text-uppercase fw-bold">
                    Drop-Off Rate
                  </div>
                  <div class="d-flex align-items-center gap-2 mb-1">
                    <!-- <div class="progress w-100" style="height:8px">
          <div class="progress-bar bg-danger" style="width:20%"></div>
        </div> -->
                    <small class="fw-semibold h4">{{ AcceptancePercentage?.COUNT1 }}%
                      <span class="badge bg-light text-success fw-semibold small">Accepted: {{
                        registeredCount?.REJECTEDCOUNT }}</span></small>
                  </div>

                  <div class="small text-muted mt-1">
                    Confirmed but didn’t register
                  </div>
                </div>

                <!-- Admissions by Source -->
                <div>
                  <div class="small text-uppercase fw-semibold text-muted mb-2">
                    Admissions by Source
                  </div>
                  <ul class="small list-unstyled ps-0 m-0">
                    <li>
                      Website:
                      <strong>
                        <a style="color: black" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                          (click)="registrationDetails(26, 'Website', 0)">{{ referalCount?.COUNT1 }}</a>
                      </strong>
                    </li>
                    <li>
                      Referrals:
                      <strong>
                        <a style="color: black" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                          (click)="registrationDetails(27, 'Website', 0)">{{ referalCount?.REVIEWCOUNT }}</a>
                      </strong>
                    </li>
                    <li>
                      Social Media:
                      <strong>
                        <a style="color: black" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                          (click)="registrationDetails(28, 'Website', 0)">{{ referalCount?.REJECTEDCOUNT }}</a>
                      </strong>
                    </li>
                    <li>
                      Others:
                      <strong>
                        <a style="color: black" href="javascript:void()" data-bs-target="#count" data-bs-toggle="modal"
                          (click)="registrationDetails(29, 'Website', 0)">{{ referalCount?.OFFERREJECTCOUNT
                          }}</a></strong>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-8">
            <div class="card card-soft h-100">
              <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-0">
                  <div class="mini-title h5 mb-0">Applications</div>

                  <div class="dropdown">
                    <select class="form-select dropdown-toggle" [(ngModel)]="showMonthly"
                      (change)="getLineChartGraphCounts($event.target.value)">
                      <option value="1">Weekly</option>
                      <option value="2">Monthly</option>
                      <option value="3">Quarterly</option>
                      <option value="4">Half-yearly</option>
                      <option value="5">Yearly</option>
                    </select>
                  </div>
                </div>
                <p class="text-muted small" style="font-size: 10px !important">
                  Application trends over time
                </p>
                <div class="chart-box w-100" style="height: 300px">
                  <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
                    [legend]="lineChartLegend" [chartType]="lineChartType">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-xl-12">
            <div class="fw-bold h5">Programmes</div>
          </div>
        </div>

        <div class="card p-4">
          <!-- Top Stats Row -->
          <div class="row mb-4 align-items-center">
            <div class="col">
              <div class="fw-bold fs-5">
                <div class="value">
                  <a class="count-color" href="javascript:void()" data-bs-target="#courseModal" data-bs-toggle="modal"
                    (click)="loadCourse()">
                    {{ dashboardCounts[0]?.ACTIVECOUNT }}</a>
                  <span class="text-muted small fw-normal">Active</span>
                  <span class="text-success ms-1">&#9650;</span>
                </div>
              </div>
              <div class="text-muted small">
                Total: {{ dashboardCounts[0]?.TOTALCOUNT }}
              </div>
            </div>

            <div class="col">
              <div class="fw-bold fs-6">
                {{ dashboardCounts[1]?.ACTIVECOUNT }}
                <a href="javascript:void()" class="text-decoration-none" data-bs-target="#shortCourse"
                  data-bs-toggle="modal" (click)="getShortCourses()">Professional Development Courses</a>
              </div>
              <div class="text-muted small">
                Total:
                <a href="javascript:void();" data-bs-target="#count" data-bs-toggle="modal" (click)="
                    registrationDetails(21, 'Short Course Student List', 0)
                  ">
                  {{ shortCoursesCount?.REJECTEDCOUNT }}</a>&nbsp; Applied:
                <a href="javascript:void()" class="text-decoration-none" data-bs-target="#count" data-bs-toggle="modal"
                  (click)="
                    registrationDetails(20, 'Short Courses Submitted', 0)
                  ">{{ shortCoursesCount?.COUNT1 }}</a>&nbsp; In Review:
                <a href="javascript:void()" class="text-decoration-none" data-bs-target="#count" data-bs-toggle="modal"
                  (click)="
                    registrationDetails(19, 'Application in Progress', 0)
                  ">{{ shortCoursesCount?.REVIEWCOUNT }}</a>
              </div>
            </div>

            <div class="col d-flex justify-content-between align-items-center">
              <div>
                <div class="value">
                  <a class="count-color" href="javascript:void()" data-bs-target="#cohortModal" data-bs-toggle="modal"
                    (click)="getCohortList()">
                    {{ dashboardCounts[2]?.ACTIVECOUNT }}</a>
                  <span class="text-muted small fw-normal">Active Cohorts</span>
                </div>
                <!-- <div class="fw-bold fs-6">
                  {{ dashboardCounts[2]?.ACTIVECOUNT }}
                  <span class="text-muted small fw-normal">Active Cohorts</span>
                </div> -->
                <div class="text-muted small">
                  Total: {{ dashboardCounts[2]?.TOTALCOUNT }}
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <select class="form-select dropdown-toggle" [(ngModel)]="showMonthly"
                  (change)="getBarChartData($event.target.value)">
                  <option value="1">Weekly</option>
                  <option value="2">Monthly</option>
                  <option value="3">Quaterly</option>
                  <option value="4">Hlaf-yearly</option>
                  <option value="5">Yearly</option>
                </select>

                <!-- <div class="dropdown">
                  <a
                    class="text-orange orage text-decoration-none small dropdown-toggle"
                    href="#"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Export
                  </a>
                  <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Download CSV</a></li>
                    <li><a class="dropdown-item" href="#">Download PDF</a></li>
                  </ul>
                </div> -->
                <div class="dropdown">
                  <button class="btn export-btn dropdown-toggle" type="button" id="exportDropdownSchools"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    Export
                    <!-- <i class="bi bi-caret-down-fill"></i> -->
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="exportDropdownSchools">
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="downloadProgrammePDF('excel')">
                        Download Excel
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="downloadProgrammePDF('pdf')">
                        Download PDF
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Chart Title -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="fw-semibold mb-0">Top 10 Programme Popularity</h6>
            <a href="javascript:void(0)" style="color: #d46a43" data-bs-target="#programModal"
              data-bs-toggle="modal">More</a>
          </div>
          <!-- Chart Container -->
          <div>
            <canvas baseChart [datasets]="barChartDataforProgramme" [labels]="barChartLabelsforProgramme"
              [options]="barChartOptionsforProgramme" [legend]="true" [chartType]="barChartType">
            </canvas>
          </div>
        </div>

        <!-- Schools & Departments -->
        <div class="row g-3 mb-2 mt-2">
          <div class="col-lg-9">
            <div class="card card-soft h-100">
              <div class="card-body">
                <div class="section-head">
                  <div class="fw-semibold">Schools and Departments</div>
                  <div class="d-flex align-items-center gap-2">
                    <!-- <div class="dropdown"> -->
                    <select class="form-select dropdown-toggle" [(ngModel)]="showMonthly"
                      (change)="getBargraphCounts($event.target.value)">
                      <option value="1">Weekly</option>
                      <option value="2">Monthly</option>
                      <option value="3">Quaterly</option>
                      <option value="4">Half-yearly</option>
                      <option value="5">Yearly</option>
                    </select>
                    <!-- </div> -->
                    <!-- <button
                      class="btn btn-light btn-sm dropdown-toggle"
                      data-bs-toggle="dropdown"
                    >
                      Monthly
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" href="javascript:void()"
                          >Monthly</a
                        >
                      </li>
                    </ul> -->
                    <div class="dropdown">
                      <button class="btn export-btn dropdown-toggle" type="button" id="exportDropdownSchools"
                        data-bs-toggle="dropdown" aria-expanded="false">
                        Export
                        <!-- <i class="bi bi-caret-down-fill"></i> -->
                      </button>
                      <ul class="dropdown-menu" aria-labelledby="exportDropdownSchools">
                        <li>
                          <a class="dropdown-item" href="javascript:void(0)" (click)="downloadSchoolPDF('excel')">
                            Download Excel
                          </a>
                        </li>
                        <li>
                          <a class="dropdown-item" href="javascript:void(0)" (click)="downloadSchoolPDF('pdf')">
                            Download PDF
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div>
                  <p style="color: #94acb3; font-size: small !important">
                    Graphical presentation of student enrollment status across
                    various schools, displaying the numbers of students who have
                    registered, applied and been admitted
                  </p>
                </div>
                <div class="chart-box">
                  <canvas baseChart [datasets]="barChartData" [labels]="barChartLabels" [options]="barChartOptions"
                    [chartType]="barChartType" [legend]="true">
                  </canvas>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card p-4 h-100">
              <!-- Header Section -->
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div>
                  <h6 class="fw-bold mb-1">Schools</h6>
                  <div class="fs-6 fw-bold">
                    {{ dashboardCounts[3]?.ACTIVECOUNT }}
                    <span class="text-muted fw-normal">Active</span>
                    <span class="text-success ms-1">&#9650;</span>
                  </div>
                  <div class="small text-muted">
                    Total: {{ dashboardCounts[3]?.TOTALCOUNT }}
                  </div>
                </div>
                <a href="javascript:void()" class="text-decoration-none orange small fw-semibold">
                  Reports <i class="bi bi-clock-history"></i>
                </a>
              </div>

              <!-- Students Section -->
              <div class="mb-3">
                <h6 class="fw-bold mb-1">Students</h6>
                <div class="small text-muted mb-2">
                  Number of students per school
                </div>

                <div class="bg-light rounded p-3">
                  <ng-container *ngFor="let school of schoolsCounts | slice : 0 : 3">
                    <div class="mb-3" *ngIf="
                        school === schoolsCounts[0] ||
                        school === schoolsCounts[1]
                      ">
                      <div class="fw-bold fs-5 mb-0">
                        {{ school.ACTIVECOUNT }}
                      </div>
                      <div class="text-muted small">{{ school.TYPENAME }}</div>
                    </div>
                    <div *ngIf="school === schoolsCounts[2]">
                      <div class="fw-bold fs-5 mb-0">
                        {{ school.ACTIVECOUNT }}
                      </div>
                      <div class="text-muted small">{{ school.TYPENAME }}</div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <!-- School-wise Trends Link -->
              <div class="mb-3">
                <a href="javascript:void()" data-bs-target="#schoolsModal" data-bs-toggle="modal"
                  class="text-decoration-none small fw-semibold text-orange">
                  School-wise Admission Trends <i class="bi bi-eye-fill"></i>
                </a>
              </div>

              <!-- Top Performing School -->
              <div>
                <span class="fw-bold mb-2 fs-6">Top Performing Schools</span>
                <div class="bg-light border-start border-4 orage-border rounded p-3 bg-opacity-50"
                  style="background-color: #fff0ec">
                  <div class="fw-semibold orage">
                    {{ schoolsCounts[0]?.TYPENAME }}
                  </div>
                  <div class="small text-muted">By highest enrollment</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Demographics -->
        <div class="row g-3 mb-4">
          <div class="col-lg-3">
            <div class="card card-soft h-100">
              <div class="card-body">
                <div class="fw-semibold mb-2">Placement</div>
                <div class="d-flex justify-content-center my-3">
                  <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [options]="pieChartOptions"
                    [colors]="pieChartColors" [chartType]="pieChartType" height="180" width="180">
                  </canvas>
                </div>
                <!-- <div
                  class="d-flex justify-content-center gap-3 small text-muted"
                >
                  <span
                    ><i class="bi bi-circle-fill text-info me-1"></i
                    >KUCCPS</span
                  ><span
                    ><i class="bi bi-circle-fill text-secondary me-1"></i
                    >PSSP</span
                  >
                </div> -->
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card card-soft h-100">
              <div class="card-body">
                <div class="fw-semibold mb-2">Inclusivity</div>
                <div class="small text-muted">
                  Overall analysis of students with disability and youths
                  against number of applications
                </div>

                <div class="mt-3">
                  <div class="mini-title">Students with disability:</div>
                  <div class="d-flex align-items-center">
                    <div class="progress w-100 me-2">
                      <div class="progress-bar bg-success" role="progressbar" [style.width.%]="Inclusivity?.COUNT1"
                        [attr.aria-valuenow]="Inclusivity?.COUNT1" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <span>{{ Inclusivity?.COUNT1 }}%</span>
                  </div>
                </div>

                <div class="mt-3">
                  <div class="mini-title">Youth:</div>
                  <div class="d-flex align-items-center">
                    <div class="progress w-100 me-2">
                      <div class="progress-bar bg-primary" role="progressbar" [style.width.%]="Inclusivity?.REVIEWCOUNT"
                        [attr.aria-valuenow]="Inclusivity?.REVIEWCOUNT" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                    <span>{{ Inclusivity?.REVIEWCOUNT }}%</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="card card-soft h-100">
              <div class="card-body">
                <div class="fw-semibold mb-2">Gender Distribution</div>
                <div class="d-flex justify-content-center my-3">
                  <canvas baseChart [data]="pieChartDataforGender" [labels]="pieChartLabelsforGender"
                    [options]="pieChartOptionsforGender" [colors]="pieChartColorsforGender" [chartType]="pieChartType"
                    height="180" width="180">
                  </canvas>
                  <!-- <div
                    class="donut"
                    style="
                      background: conic-gradient(#f2a9c6 0 40%, #93c5fd 0 100%);
                    "
                  ></div> -->
                </div>
                <!-- <div
                  class="d-flex justify-content-center gap-3 small text-muted"
                >
                  <span
                    ><i class="bi bi-circle-fill text-danger me-1"></i
                    >Female</span
                  ><span
                    ><i class="bi bi-circle-fill text-primary me-1"></i
                    >Male</span
                  >
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- Geographical Distribution -->
        <div class="card p-4">
          <!-- Header: Title + Controls -->
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div>
              <h5 class="fw-bold">Geographical Distribution</h5>

              <!-- Tabs -->
              <ul class="nav nav-tabs border-0 mt-2" id="studentTabs" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link fw-semibold" [ngClass]="{
                      'active text-orange border-0 border-bottom border-2 border-warning':
                        studentsStatusForLocalOrInternational === 1,
                      'text-muted border-0':
                        studentsStatusForLocalOrInternational !== 1
                    }" id="local-tab" data-bs-toggle="tab" data-bs-target="#local" type="button" role="tab"
                    aria-controls="local" [attr.aria-selected]="
                      studentsStatusForLocalOrInternational === 1
                    " (click)="getStatusForLocalOrInternational(1)">
                    Local Students
                  </button>
                </li>

                <li class="nav-item" role="presentation">
                  <button class="nav-link fw-semibold" [ngClass]="{
                      'active text-orange border-0 border-bottom border-2 border-warning':
                        studentsStatusForLocalOrInternational === 2,
                      'text-muted border-0':
                        studentsStatusForLocalOrInternational !== 2
                    }" id="international-tab" data-bs-toggle="tab" data-bs-target="#international" type="button"
                    role="tab" aria-controls="international" [attr.aria-selected]="
                      studentsStatusForLocalOrInternational === 2
                    " (click)="getStatusForLocalOrInternational(2)">
                    International Students
                  </button>
                </li>
              </ul>

              <div class="small text-muted mt-2">
                Number of students distributed per the top 10
                {{
                studentsStatusForLocalOrInternational == 1
                ? "County"
                : "country"
                }}
              </div>
            </div>

            <!-- Dropdown + Map -->
            <div class="d-flex align-items-center gap-3">
              <select class="form-select form-select-sm" style="width: auto" (change)="
                  studentsStatusForLocalOrInternational == 1
                    ? getBarChartDataForLocalStudents($event.target.value)
                    : getBarChartDataForInternationalStudents(
                        $event.target.value
                      )
                " [(ngModel)]="showMonthly">
                <option value="1">Weekly</option>
                <option value="2">Monthly</option>
                <option value="3">Quarterly</option>
                <option value="4">Half-Yearly</option>
                <option value="5">Yearly</option>
              </select>
              <!-- <a
                href="#"
                class="text-decoration-none text-orange small fw-semibold d-flex align-items-center"
              >
                <i class="bi bi-map me-1"></i> View Map
              </a> -->
            </div>
          </div>

          <!-- Chart Area -->
          <div class="tab-content" id="studentTabsContent">
            <!-- Local Students Tab -->
            <div class="tab-pane fade show active" id="local" role="tabpanel" aria-labelledby="local-tab">
              <canvas baseChart [datasets]="barChartDataforLocalStudents" [labels]="barChartLabelsforLocalStudents"
                [options]="barChartOptionsforLocalStudents" [legend]="true" [chartType]="barChartType">
              </canvas>
            </div>

            <!-- International Students Tab -->
            <div class="tab-pane fade" id="international" role="tabpanel" aria-labelledby="international-tab">
              <canvas baseChart [datasets]="barChartDataforInternationalStudents"
                [labels]="barChartLabelsforInternationalStudents" [options]="barChartOptionsforInternationalStudents"
                [legend]="true" [chartType]="barChartType">
              </canvas>
            </div>
          </div>

          <!-- More Link -->
          <div class="text-end mt-3">
            <a href="javascript:void(0)" class="text-decoration-none text-orange small fw-semibold"
              data-bs-target="#studentsModal" data-bs-toggle="modal">
              More
            </a>
          </div>
        </div>
      </div>

      <!-- Notes Section -->
      <div class="bg-light-gray p-4 d-none">
        <h6 class="fw-bold">NOTES</h6>
        <p class="mb-1">
          Graphical distribution for international students is per country
        </p>
        <p class="mb-3">
          <strong>Label Student(s):</strong> Represents Registered Student
        </p>

        <div class="d-flex align-items-center gap-2 mb-3">
          <!-- Export Dropdown -->
          <div class="dropdown">
            <button class="btn btn-sm btn-orange-outline dropdown-toggle" type="button" id="exportDropdown"
              data-bs-toggle="dropdown" aria-expanded="false">
              Export
            </button>
            <ul class="dropdown-menu" aria-labelledby="exportDropdown">
              <li><a class="dropdown-item" href="#">Download PDF</a></li>
              <li><a class="dropdown-item" href="#">Download Excel</a></li>
            </ul>
          </div>
          <span>Export dropdown shows PDF and Excel file format</span>
        </div>

        <p class="mb-3">Trend charts, to be line graphs</p>

        <div class="d-flex align-items-center gap-2">
          <!-- View Map Button -->
          <a href="#" class="btn btn-sm btn-orange-outline d-flex align-items-center gap-1">
            <i class="bi bi-map"></i> View Map
          </a>
          <span>To be country distribution view</span>
        </div>
      </div>
    </div>
    <!--end page wrapper -->
  </div>
</div>

<div class="modal" tabindex="-1" id="count">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ headerText }}</h5>
        <button type="button" class="btn-close" (click)="closeModal()" data-bs-dismiss="modal"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div style="display: flex; gap: 5px" *ngIf="responseData.length">
          <button class="btn btn-save" (click)="downloadPDF('excel')">
            EXCEL
          </button>
          <button class="btn btn-save" (click)="downloadPDF('pdf')">PDF</button>
        </div>
        <div class="row mb-2">
          <div class="col-xl-9"></div>
          <div class="col-xl-3">
            <input type="text" class="form-control" placeholder="Search" [(ngModel)]="srchFltr"
              (keyup)="search($event.target.value)">
          </div>
        </div>
        <div class="table-responsive pt-4" *ngIf="responseData.length">
          <!-- [dtOptions]="dtOptions" -->
          <table class="custom-user-table mt-2 pt-2" style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>S.No</th>
                <th *ngIf="headerText != 'Alumni'">Reference Number</th>
                <ng-container *ngIf="headerText != 'Alumni'">
                  <th *ngIf="txt || Admitted">Registration Number</th>
                </ng-container>
                <th>First Name</th>
                <th *ngIf="headerText == 'Registered'">ID Type</th>
                <th *ngIf="headerText == 'Registered'">ID Number</th>
                <th *ngIf="headerText == 'Registered'">Index number</th>
                <th>Surname</th>
                <th *ngIf="headerText != 'Alumni'">Programme Name</th>
                <!-- <th *ngIf="!txt">Verification Status</th>
                <th  *ngIf="!txt">Application Status</th>
                <th  *ngIf="!txt">Submission Status</th> -->
                <th *ngIf="!txt">Application Status</th>
                <th *ngIf="(txt || headerText != 'Alumni')&&![19,20,21].includes(status)">
                  Registration Status
                </th>
                <th *ngIf="!txt">Applied Date</th>
                <th *ngIf="!txt">Sign Up Date</th>
                <th *ngIf="headerText == 'Admitted'">Admission Date</th>
                <th *ngIf="headerText == 'Accepted'">Acceptance Date</th>
                <th *ngIf="headerText != 'Alumni'">Username</th>
                <th *ngIf="headerText != 'Short Courses Submitted'">
                  Personal Email
                </th>
                <th>Mobile Number</th>
                <th>Date Of Birth</th>
                <th>Gender</th>
                <th *ngIf="![19,20,21].includes(status)">Country</th>
                <th *ngIf="![19,20,21].includes(status)">County</th>
                <th *ngIf="![19,20,21].includes(status)">Sub County</th>
                <th *ngIf="headerText == 'Initiated'">
                  Registration Initiated Date
                </th>
                <th *ngIf="headerText == 'Registered'">
                  Registration Approved Date
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="let item of responseData| paginate: { id: 'tblscLst', itemsPerPage: pgSze, currentPage: crntPage, totalItems: ttlItms }; let i = index">
                <td>{{(pgSze*(crntPage-1))+i+1}}
                </td>
                <td *ngIf="headerText != 'Alumni'">{{ item.REFCODE1 }}</td>
                <ng-container *ngIf="headerText != 'Alumni'">
                  <td *ngIf="txt || Admitted">{{ item.REGISTRATION_NO }}</td>
                </ng-container>

                <td>{{ item.FIRSTNAME1 }}</td>
                <td *ngIf="headerText == 'Registered'">
                  {{ item.ID_PASSPORT_TYPE_NAME1 }}
                </td>
                <td *ngIf="headerText == 'Registered'">{{ item.PAAPORT1 }}</td>
                <td *ngIf="headerText == 'Registered'">
                  {{ item.EXAM_REG_NO1 }}
                </td>
                <td>{{ item.LASTNAME1 }}</td>
                <td *ngIf="headerText != 'Alumni'">{{ item.COURSENAME1 }}</td>
                <!-- <td *ngIf="!txt">{{item.VERIFICATIONSTATUS1}}</td>
                <td *ngIf="!txt">{{item.APPLICATIONSTATUS1}}</td>
                <td *ngIf="!txt">{{item.SUBMITIONSTATUS1}}</td> -->
                <td *ngIf="!txt">{{ item.SUBMITIONSTATUS1 }}</td>
                <td *ngIf="(txt || headerText != 'Alumni')&&![19,20,21].includes(status)">
                  {{ item.ENROLEDSTATUS1 }}
                </td>
                <td *ngIf="!txt">
                  {{
                  item.APPICATIONDATE1 == "NA" ? "NA" : item.APPICATIONDATE1
                  }}
                </td>
                <td *ngIf="!txt">{{ item.SIGNUPDATE1 }}</td>
                <td *ngIf="headerText == 'Admitted'">
                  {{ item.ADMITTEDDATE }}
                </td>
                <td *ngIf="headerText == 'Accepted'">
                  {{ item.ACCEPTEDDATE }}
                </td>
                <td *ngIf="headerText != 'Alumni'">{{ item.USERNAME1 }}</td>
                <td *ngIf="headerText != 'Short Courses Submitted'">
                  {{ item.INITIALUSERNAME }}
                </td>
                <td>{{ item.MOBILE1 }}</td>
                <td>{{ item.DOB1 }}</td>
                <td>{{ item.GENDER1 }}</td>
                <td *ngIf="![19,20,21].includes(status)">{{ item.COUNTRY_NAME }}</td>
                <td *ngIf="![19,20,21].includes(status)">{{ item.COUNTIES_NAME }}</td>
                <td *ngIf="![19,20,21].includes(status)">{{ item.SUB_COUNTIES_NAME }}</td>
                <td *ngIf="headerText == 'Initiated'">
                  {{ item.REGINITDATE }}
                </td>
                <td *ngIf="headerText == 'Registered'">
                  {{ item.REGAPPDATE }}
                </td>
                <!-- <td></td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!responseData.length">
          No Records to display
        </div>
        <div class="col-xl-12 pt-2" *ngIf="responseData.length!=0">
          <div class="row mb-0">
            <div class="col-xl-6">
              <div class="mt-2">{{pageEntry}}</div>
            </div>
            <div class="col-xl-6 text-end">
              <pagination-controls previousLabel="" id="tblscLst" nextLabel=""
                (pageChange)="setPage($event)"></pagination-controls>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" id="programmePopup">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Programmes</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div style="display: flex; gap: 5px" *ngIf="graduatedProgrames.length">
          <button class="btn btn-save" (click)="downloadPDF('excel')">
            EXCEL
          </button>
          <button class="btn btn-save" (click)="downloadPDF('pdf')">PDF</button>
        </div>
        <div class="table-responsive pt-4" *ngIf="graduatedProgrames.length">
          <table datatable class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>S.No</th>
                <th>Programme Code</th>
                <th>Programme Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of graduatedProgrames; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item.COURSE_CODE }}</td>
                <td>{{ item.COURSE_NAME }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!graduatedProgrames.length">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" id="programModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Programmes</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive pt-2" *ngIf="allProgramees.length">
          <table datatable id="patreggraph" class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>Programme Code</th>
                <!-- <th>Programme Name</th> -->
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of allProgramees">
                <td>{{ item.MONTHNAME }}</td>
                <!-- <td>{{ item.COURSE_NAME }}</td> -->
                <td>{{ item.USERCOUNT }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!allProgramees.length">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" id="studentsModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-center">
          {{
          studentsStatusForLocalOrInternational == 1
          ? "Local Students"
          : "International Students"
          }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive pt-2" *ngIf="
            studentsStatusForLocalOrInternational == 1
              ? localCounties.length
              : internationalCountry?.length
          ">
          <table datatable id="patreggraph" class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>
                  {{
                  studentsStatusForLocalOrInternational == 1
                  ? "County"
                  : "Country"
                  }}
                </th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="studentsStatusForLocalOrInternational == 1">
                <tr *ngFor="let item of localCounties">
                  <td>{{ item.MONTHNAME }}</td>
                  <td>{{ item.USERCOUNT }}</td>
                </tr>
              </ng-container>
              <ng-container *ngIf="studentsStatusForLocalOrInternational != 1">
                <tr *ngFor="let item of internationalCountry">
                  <td>{{ item.MONTHNAME }}</td>
                  <td>{{ item.USERCOUNT }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="
            studentsStatusForLocalOrInternational == 1
              ? !localCounties.length
              : !internationalCountry?.length
          ">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" tabindex="-1" id="schoolsModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Schools</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive pt-2" *ngIf="schoolsCounts.length">
          <table datatable id="patreggraph" class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>School Name</th>
                <th>Count</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of schoolsCounts">
                <td>{{ item.TYPENAME }}</td>
                <td>{{ item.ACTIVECOUNT }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!schoolsCounts.length">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" id="shortCourse">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Professional Development Courses</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive pt-2" *ngIf="shortCoursesData.length">
          <table datatable id="patreggraph" class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>Department</th>
                <th>Short Course Code</th>
                <th>Short Course Name</th>
                <th>Short Course Fee In KES</th>
                <th>Short Course Fee In USD</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of shortCoursesData">
                <td>{{ item.DEPARTMENT_NAME }}</td>
                <td>{{ item.COURSE_CODE }}</td>
                <td>{{ item.COURSE_NAME }}</td>
                <td>{{ item.COURSE_FEES }}</td>
                <td>{{ item.COURSE_FEES_USD }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!shortCoursesData.length">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" id="courseModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Programmes</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive pt-2" *ngIf="programmes.length">
          <table datatable id="patreggraph" class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>School</th>
                <th>Programme Code</th>
                <th>Programme Name</th>
                <th>KUCCPS Programme ID</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of programmes">
                <td>{{ item.COURSE_CATEGORY_NAME }}</td>
                <td>{{ item.COURSE_CODE }}</td>
                <td>{{ item.COURSE_NAME }}</td>
                <td>{{ item.KUCCPS_COURSE_ID }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!programmes.length">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" id="cohortModal">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Cohorts</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="table-responsive pt-2" *ngIf="cohortsData.length">
          <table datatable id="patreggraph" class="table-striped table-bordered mt-2 pt-2 table-sm small"
            style="width: 100%; white-space: nowrap">
            <thead class="top" style="background-color: #624fd7; color: #ffffff">
              <tr>
                <th>Academic Year</th>
                <th>Cohort Name</th>
                <th>Commencement Date</th>
                <th>Application Start Date</th>
                <th>Application End Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of cohortsData">
                <td>{{ item.ACADEMIC_NAME }}</td>
                <td>{{ item.COHORT_NAME }}</td>
                <td>{{ item.COMMENCEMENT_DATE }}</td>
                <td>{{ item.APPLICATION_STARTDATE }}</td>
                <td>{{ item.APPLICATION_ENDDATE }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="text-center" *ngIf="!cohortsData.length">
          No Records to display
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
      </div>
    </div>
  </div>
</div>